/**
 * Search Store — Zustand 搜索状态管理
 */

import { create } from 'zustand';

interface SearchState {
  // 搜索状态
  query: string;
  activeTab: 'all' | 'pois' | 'hotels' | 'attractions' | 'guides';
  recentSearches: string[];
  selectedCity: string | null;

  // Actions
  setQuery: (query: string) => void;
  setActiveTab: (tab: SearchState['activeTab']) => void;
  setCity: (city: string | null) => void;
  addRecentSearch: (query: string) => void;
  clearRecentSearches: () => void;
}

const MAX_RECENT = 10;

export const useSearchStore = create<SearchState>((set, get) => ({
  query: '',
  activeTab: 'all',
  recentSearches: [],
  selectedCity: null,

  setQuery: (query) => set({ query }),

  setActiveTab: (tab) => set({ activeTab: tab }),

  setCity: (city) => set({ selectedCity: city }),

  addRecentSearch: (query) => {
    if (!query.trim()) return;
    const current = get().recentSearches;
    const filtered = current.filter(q => q !== query);
    const updated = [query, ...filtered].slice(0, MAX_RECENT);
    set({ recentSearches: updated });
  },

  clearRecentSearches: () => set({ recentSearches: [] }),
}));
